import { combineReducers } from "@reduxjs/toolkit";
import {
  leadReducer,
  sidebarReducer,
  taskReducer,
  commentsReducer,
  dropdownLeadReducer,
  leadActivityReducer,
  userDetailReducer,
  tableStatesReducer,
  callRecordReducer,
  CustomerDataReducer,
  projectReducer,
  sourceReducer,
  usersReducer,
  adminleadReducer,
  dashboardTaskStatsReducer,
  dashboardLeadStatsReducer,
  userDashboardStateReducer,
  dashboardWidgetReducer,
  contactReducer,
  companyReducer,
  tokenReducer,
  inventoryReducer,
  dashboardCardsReducer,
  staffTargetReducer,
  individualInventoryReducer,
  projectBlockReducer,
  projectPhaseReducer,
  teamReducer,
  projectAssignmentReducer,
  userPermissionReducer,
  userSettingReducer,
  userPrimaryDashboardStateReducer,
  dashboardCardDataReducer,
  allActivityReducer,
  projectDocumentRedcuer,
  salesSliceReducer,
  adminInventoryReducer,
} from "store/slices";

export const appReducer = combineReducers({
  sidebarReducer: sidebarReducer,
  leadReducer: leadReducer,
  taskReducer: taskReducer,
  commentsReducer: commentsReducer,
  dropdownLeadReducer: dropdownLeadReducer,
  leadActivityReducer: leadActivityReducer,
  userDetailReducer: userDetailReducer,
  tableStatesReducer: tableStatesReducer,
  callRecordReducer: callRecordReducer,
  CustomerDataReducer: CustomerDataReducer,
  projectReducer: projectReducer,
  sourceReducer: sourceReducer,
  usersReducer: usersReducer,
  adminleadReducer: adminleadReducer,
  dashboardTaskStatsReducer: dashboardTaskStatsReducer,
  dashboardLeadStatsReducer: dashboardLeadStatsReducer,
  userDashboardStateReducer: userDashboardStateReducer,
  dashboardWidgetReducer: dashboardWidgetReducer,
  contactReducer: contactReducer,
  companyReducer: companyReducer,
  tokenReducer: tokenReducer,
  inventoryReducer: inventoryReducer,
  dashboardCardsReducer: dashboardCardsReducer,
  staffTargetReducer: staffTargetReducer,
  individualInventoryReducer: individualInventoryReducer,
  projectBlockReducer: projectBlockReducer,
  projectPhaseReducer: projectPhaseReducer,
  teamReducer: teamReducer,
  projectAssignmentReducer: projectAssignmentReducer,
  userPermissionReducer: userPermissionReducer,
  userSettingReducer: userSettingReducer,
  userPrimaryDashboardStateReducer: userPrimaryDashboardStateReducer,
  dashboardCardDataReducer: dashboardCardDataReducer,
  allActivityReducer: allActivityReducer,
  projectDocumentRedcuer: projectDocumentRedcuer,
  salesSliceReducer: salesSliceReducer,
  adminInventoryReducer: adminInventoryReducer,
});

export const rootReducer = (state: any, action: any) => {
  // Reset entire store to initial state

  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
